import React, {Component} from 'react';
import ShowOptionalLabel from '../ShowOptionalLabel'
import ShowOptionalField from '../ShowOptionalField'
import ShowTipoSoggetto from './ShowTipoSoggetto'
import OrgMiniView from './OrgMiniView'
import DipMiniView from './DipMiniView'

class RubricaSearchTableRow extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        let c = this.props.item
        return (
            <tr>
                <td className="">
                    <div className="content">
                        <b>{c.tit} {c.nomeCognome}</b>&nbsp;<ShowTipoSoggetto soggetto={c}/>
                        <div className="sub header">
                            <div>{c.indirizzo} {c.cap} {c.citta} {c.provincia} {c.stato}</div>
                            <div><ShowOptionalField label="C.Fisc." value={c.cfisc}/><ShowOptionalField label="P.IVA" value={c.piva}/></div>
                            <div className="sub header">
                                <ShowOptionalLabel title="Telefono 1"    value={c.telefono1} icon="voulme control phone" extraClassName="left floated" />
                                <ShowOptionalLabel title="Telefono 2"    value={c.telefono2} icon="voulme control phone" extraClassName="left floated"  />
                                <ShowOptionalLabel title="Cellulare"    value={c.cellulare} icon="mobile" extraClassName="left floated"  />
                                <ShowOptionalLabel title="FAX"    value={c.fax} icon="fax" extraClassName="left floated"  />
                                <ShowOptionalLabel title="e-mail"    value={c.email} icon="mail" extraClassName="left floated"  />
                                <ShowOptionalLabel title="PEC"    value={c.pec} icon="mail" extraClassName="left floated"  />
                                <ShowOptionalLabel title="Cellulare personale"    value={c.perCellulare} icon="mobile" extraClassName="left floated"  />
                                <ShowOptionalLabel title="e-mail personale"    value={c.perEmail} icon="mail" extraClassName="left floated"  />
                            </div>
                            <div className="content">
                                <i>{c.note}</i>
                            </div>
                        </div>
                    </div>
                </td>
                <td className="">

                    <div className="content">
                        {c.idDipartimento.nomeCompleto}
                        <DipMiniView item={c.idDipartimento} />
                    </div>
                </td>
                <td className="">
                    <div className="content">
                        {c.idDipartimento.idOrganizzazione.nomeCompleto}
                        <OrgMiniView item={c.idDipartimento.idOrganizzazione} />
                    </div>
                </td>
                <td className="collapsing no-print">
                    <a className="ui green icon button" title="Scegli questo Soggetto" href="#" onClick={(ev) => (this.props.onSelectSoggetto(c))}>
                        <i className="external alternate icon"/>
                    </a>
                </td>
            </tr>)
    }
}

export default RubricaSearchTableRow;




/** WEBPACK FOOTER **
 ** ./src/components/rubrica/RubricaSearchTableRow.js
 **/